import React from 'react'
import { Table } from 'reactstrap'

const FleetAssessmentTable = (graphData: any) => {
    console.log(graphData)
    return (
        <div className="table-responsive mb-5">
            <Table className="table mb-0" size='sm'>
                <thead className="table-light">
                    <tr>
                        <th>Sr. No.</th>
                        <th>Vessel name</th>
                        <th>Vessel Type</th>
                        <th>CII rating</th>
                        <th>Req CII</th>
                        <th>Att CII</th>
                        <th>CII ratio</th>
                        {/* <th>EUA</th>
                        <th>CO<sub>2</sub> Emission</th>
                        <th>Methane Emission</th>
                        <th>N<sub>2</sub>O Emission</th> */}
                    </tr>
                </thead>
                <tbody>
                    {graphData.graphData?.map((data: any, index: number) => {
                        return (
                            <tr>
                                <td className='align-middle'>{index + 1}</td>
                                <td className='align-middle'>{data?.vessel_name}</td>
                                <td className='align-middle'>{data?.vessel_type}</td>
                                <td className='align-middle'><div className={`background-${data?.cii_grade} 
                                ${data?.cii_grade === 'C' ? 'fleet-tbl-rating-C' : 'fleet-tbl-rating'}`}>{data?.cii_grade}</div></td>
                                <td className='align-middle'>{data?.required_cii}</td>
                                <td className='align-middle'>{data?.attained_cii}</td>
                                <td className='align-middle'>{data?.cii_rating}</td>
                                {/* <td>150</td>
                                <td>100</td>
                                <td>100</td>
                                <td>100</td> */}
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default FleetAssessmentTable